import { Package } from 'lucide-react';
import { useInventory } from '../hooks';

export function InventoryView() {
  const { items, loading, error } = useInventory();

  const byCat: Record<string, typeof items> = {};
  items.forEach((it) => {
    (byCat[it.category] ||= []).push(it);
  });

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-xl font-semibold text-white">Inventario</h1>
        <p className="text-xs text-white/50">
          Items que se usan para matchear contra obras de Compranet. El scoring multiplica esta lista por el peso 50%.
        </p>
      </header>

      {error ? <div className="o-card border-red-500/30 text-sm text-red-300">{error}</div> : null}
      {loading ? <div className="text-sm text-white/50">Cargando...</div> : null}

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {Object.entries(byCat).map(([cat, list]) => (
          <div key={cat} className="o-card">
            <h3 className="mb-2 flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider text-white/60">
              <Package size={12} />
              {cat}
              <span className="ml-auto text-white/30">{list.length}</span>
            </h3>
            <ul className="space-y-1 text-xs">
              {list.map((it) => (
                <li key={it.id} className="flex justify-between border-b border-white/5 py-1 text-white/80 last:border-0">
                  <span>{it.name}</span>
                  {it.daily_rate_mxn ? (
                    <span className="text-white/40">${it.daily_rate_mxn.toLocaleString()}/día</span>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
